// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';
import GuestMiddleware from '@middleware/GuestMiddleware';

// Layouts
import LayoutAuth from '@layouts/LayoutAuth';
import OidcUtil from '@utils/OidcUtil';

export default {
    path: '/',
    component: LayoutAuth,
    children: [
        {
            path: 'login',
            name: 'login',
            component: () => import('@pages/auth/PageAuthLogin'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.log_in',
            },
        },
        {
            path: 'auth/sso/callback',
            name: 'sso.callback',
            beforeEnter(to, from, next) {
                const returnTo = OidcUtil.returnToFromState(to.query.state);
                next({
                    name: OidcUtil.routeNameForReturnTo(returnTo),
                    query: to.query,
                    replace: true,
                });
            },
        },
        {
            path: 'signup',
            name: 'signup',
            component: () => import('@pages/auth/PageAuthSignup'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.sign_up',
            },
        },
        {
            path: 'password-reset',
            name: 'password-reset',
            component: () => import('@pages/auth/PageAuthPasswordReset'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.reset_password',
            },
        },
        {
            path: 'password-change/:temp_token',
            name: 'password-change',
            component: () => import('@pages/auth/PageAuthPasswordChange'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.change_password',
            },
        },
        {
            path: 'setup',
            name: 'setup',
            component: () => import('@pages/auth/PageAuthSetup'),
            meta: {
                middleware: AuthMiddleware,
                title: 'titles.setup',
            },
        },
        {
            path: 'select-project',
            name: 'select-project',
            component: () => import('@pages/auth/PageAuthSelectProject'),
            meta: {
                middleware: AuthMiddleware,
                title: 'titles.select_project',
            },
        },
        {
            path: 'oauth/consent',
            name: 'oauth.consent',
            component: () => import('@pages/auth/PageOauthConsent'),
            meta: {
                middleware: AuthMiddleware,
                title: 'titles.authorize',
            },
        },
        {
            path: 'verify-email/:temp_token',
            name: 'verify-email',
            component: () => import('@pages/auth/PageAuthVerifyEmail'),
            meta: {
                title: 'titles.verify_email_address',
            },
        },
        {
            path: 'accept-invite/:token',
            name: 'accept-invite',
            component: () => import('@pages/auth/PageAuthAcceptInvite'),
            meta: {
                title: 'titles.accept_invite',
            },
        },
        {
            path: 'mfa',
            name: 'mfa',
            component: () => import('@pages/auth/PageAuthMFA'),
            meta: {
                title: 'titles.two_factor_authentication',
            },
        },
    ],
};